export const SESSION_STORAGE_PREFIX = 'jobtracker.session.';

export const clearAuthSessionStorage = () => {
  try {
    for (const key of Object.keys(window.sessionStorage)) {
      if (key.startsWith(SESSION_STORAGE_PREFIX)) {
        window.sessionStorage.removeItem(key);
      }
    }
  } catch {
    // Auth changes must also work when browser storage is unavailable.
  }
};
